import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const DocumentAttributeNavigationContext = createContext(null);

export const DocumentAttributeNavigationProvider = ({
  value = null,
  children,
}) => {
  return React.createElement(
    DocumentAttributeNavigationContext.Provider,
    { value },
    children
  );
};

DocumentAttributeNavigationProvider.propTypes = {
  value: PropTypes.shape({
    openDocumentTab: PropTypes.func,
    searchQuery: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  children: PropTypes.node.isRequired,
};

const useDocumentAttributeNavigation = () => {
  return useContext(DocumentAttributeNavigationContext);
};

export default useDocumentAttributeNavigation;
